module.exports = __webpack_public_path__ + "img/uvlek.ef1df6b2.png";